import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AppConstant } from '@app/app.constant';
import { AuthApiService } from '@shared/services/auth-api.service';
import { GlobalService } from '../services/global.service';
import { concatMap, map, take } from 'rxjs/operators';
import { GroupApiService } from '@app/shared/services/group-api.service';
import { PolicyValues } from '@app/modules/permission/policy.constant';

@Injectable({
    providedIn: 'root'
})
export class UserResolver  {
    constructor(
        private router: Router,
        private globalService: GlobalService,
        private authApiService: AuthApiService,
        private groupApiService: GroupApiService
    ) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        return this.loadUserProfile();
    }

    loadUserProfile(from?) {
        return new Observable<void>(observer => {
            this.globalService.storage.watch(AppConstant.GLOBAL_STORAGE.GROUPS_PERMISSIONS).pipe(take(1))
                .subscribe(data => {
                    if (!data || !data.length) {
                        return this.authApiService.getUserProfile()
                            .pipe(concatMap(user => {
                                this.globalService.storage.dispatch(AppConstant.GLOBAL_STORAGE.USER, user);
                                return this.groupApiService.getGroups();
                            }))
                            .subscribe(groups => {
                                // Hardcode
                                // Add full policy for "system" and "org" groups
                                groups.forEach(group => {
                                    if (['system', 'org'].includes(group.scope)) {
                                        if (!group.viewPolicy) {
                                            group.viewPolicy = {
                                                policy: []
                                            };
                                        }
                                        group.viewPolicy['policy'] = PolicyValues;
                                    }
                                });
                                this.globalService.storage.dispatch(AppConstant.GLOBAL_STORAGE.GROUPS_PERMISSIONS, groups);
                                observer.next();
                                observer.complete();
                            });
                    } else {
                        observer.next();
                        observer.complete();
                    }
                });
        });
    }
}
